import { render, staticRenderFns } from "./CommonBadgesList.vue?vue&type=template&id=754efb41"
import script from "./CommonBadgesList.vue?vue&type=script&lang=js"
export * from "./CommonBadgesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports